import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../../../shared/store/application-state';
import { NavigationQuery } from '../../../../store/navigation.reducer';

@Component({
	selector: 'bas-nav-basket',
	templateUrl: './basket.component.html',
	styleUrls: ['./basket.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class BasketComponent {

	private readonly store = inject(Store<ApplicationState>);
	private basket = this.store.selectSignal(NavigationQuery.getBasket);
	shoppingcartHasItems = computed(() => !!this.basket()?.shoppingcartsize);
	shoppingcartTooltip = computed(() => this.shoppingcartHasItems() ? 'text.link.tobasket' : 'basket.title.inactive');

}
